<script lang="ts">
	import InquirySendSetting from "../../organisms/settings/InquirySendSetting.svelte";
	import InquiryReceiveSetting from "../../organisms/settings/InquiryReceiveSetting.svelte";
	import InquirySignature from "../../organisms/settings/InquirySignatureSetting.svelte";
	import InquirySendTest from "../../organisms/settings/InquirySendTest.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
  	<InquirySendSetting/>

		<InquirySendTest klass="mt-8" />
	</div>

	<div class="flex-1">
 		<InquiryReceiveSetting/>

 		<InquirySignature klass="mt-8" />
	</div>
</div>